import { TFunction } from 'i18next';
import { Trans } from 'react-i18next';
import { checkMark } from '../../../../core/components/List/Checked/CheckedList';
import { FeatureTrans } from '../../../utils/locale';

export const featureItem = (trans: FeatureTrans | undefined, t: TFunction, icon = checkMark) => {
  if (!trans) return null;
  const text = t([`pricing.features.${trans[0]}`, ''], trans[1]);
  if (!text.length) return null;
  return (
    <li key={`${trans[0]}`}>
      {icon}
      <div>
        <Trans i18nKey={`pricing.features.${trans[0]}`} values={trans[1]} />
      </div>
    </li>
  );
};
